import { InfoCircle } from '@awazevr/design-system.components.icon';
import type { IconProps } from '@awazevr/design-system.components.icon';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

type StyledInfoCircleProps = IconProps & HTMLAttributes<SVGElement>;

export const StyledInfoCircle = styled(InfoCircle)<StyledInfoCircleProps>`
    cursor: pointer;
`